// Step 1 — pick the visit date. Seven big day-cards; tapping one advances
// immediately (the reducer goes straight to loading-ticket-types).

import { KioskShell } from "../components/KioskShell";
import { useLang } from "../i18n/LangContext";
import { dateParts, upcomingDates } from "../lib/format";
import type { Dispatch } from "./shared";

const DAYS = 7;

export function DateScreen({ dispatch }: { dispatch: Dispatch }) {
  const { t, locale } = useLang();
  const dates = upcomingDates(DAYS);
  return (
    <KioskShell onCancel={() => dispatch({ type: "cancel" })} step={1}>
      <div className="screen screen--wide screen--center">
        <h1 className="screen__title">{t("dateTitle")}</h1>
        <p className="screen__subtitle">{t("dateSubtitle")}</p>
        <div className="day-grid">
          {dates.map((iso, i) => {
            const parts = dateParts(iso, locale);
            return (
              <button
                className="day-card"
                key={iso}
                onClick={() => dispatch({ type: "set-date", date: iso })}
                type="button"
              >
                <span className="day-card__dow">{parts.weekday}</span>
                <span className="day-card__num">{parts.day}</span>
                <span className="day-card__mon">{parts.month}</span>
                {i === 0 ? (
                  <span className="day-card__badge">{t("today")}</span>
                ) : null}
              </button>
            );
          })}
        </div>
      </div>
    </KioskShell>
  );
}
